import React, { useEffect, useState } from "react";
import { Store } from "lucide-react";
import { Card } from "@/components/ui/card";
import { api } from "@/lib/api";
import PortalAccessActions from "@/components/PortalAccessActions";
import PartnerAnalyticsPanel from "@/components/PartnerAnalyticsPanel";

export default function PartnerPortalCard() {
  const [portal, setPortal] = useState(null);
  useEffect(() => { api.get("/me/distributing-partner-portal").then((response) => setPortal(response.data)).catch(() => setPortal({ linked: false })); }, []);
  if (!portal?.linked) return null;
  return (
    <Card className="mb-4 border-amber-300 p-5" data-testid="dp-dashboard-portal-card">
      <p className="label-eyebrow text-amber-800">Distributing Partner tools</p>
      <h2 className="mt-1 flex items-center gap-2 text-lg font-bold"><Store size={18} /> Your Client sub-portal</h2>
      <p className="mt-1 text-xs text-gray-600">Your approved portal uses your profile pricing split: {Number(portal.pricing_discount_percent || 0).toFixed(1)}% off retail.</p>
      <div className="mt-4"><PortalAccessActions portalUrl={`${window.location.origin}${portal.portal_path}`} name={portal.partner_name} testPrefix="dp-dashboard-portal" /></div>
      <PartnerAnalyticsPanel partnerId={portal.partner_id} />
    </Card>
  );
}